import { TableKey } from '@tradecafe/types/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

export interface TemplateLogOverlayOptions {
  title: string;
  templateId: string;
}

@Component({
  selector: 'tc-template-log-overlay',
  templateUrl: './template-log-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TemplateLogOverlayComponent {
  private dialogData = inject<TemplateLogOverlayOptions>(MAT_DIALOG_DATA)
  private dialogRef = inject<MatDialogRef<TemplateLogOverlayComponent, void>>(MatDialogRef)


  tableIdentity = TableKey.LogisticsFreightRatesAudit;
  title = this.dialogData.title;
  auditLogFilter = {
    component: ["template"],
    resource_id: [this.dialogData.templateId.toString()],
  };
  cancel() {
    this.dialogRef.close();
  }
}